import React from 'react';
import { FaPlus, FaMinus, FaTrash, FaTimes, FaSpinner } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import imageConfig from '../utils/imageConfig';
import './CartModal.css';

const CartModal = ({ isOpen, onClose, onCheckout, isLoading }) => {
  const { cartItems, totalPrice, removeFromCart, updateQuantity, clearCart } = useCart();

  // Format price from cents to currency
  const formatPrice = (priceInCents) => {
    return (priceInCents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'KES'
    });
  };

  if (!isOpen) return null;

  return (
    <div className="cart-modal-overlay">
      <div className="cart-modal">
        <div className="cart-modal-header">
          <h2>Your Cart</h2>
          <button className="close-modal" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <p>Your cart is empty</p>
          </div>
        ) : (
          <>
            <div className="cart-modal-items">
              {cartItems.map(item => {
                const imageName = imageConfig[item.Id] || 'default.jpg';
                const imagePath = `/assets/images/${imageName}`;
                
                return (
                  <div className="cart-modal-item" key={item.Id}>
                    <div className="cart-item-image">
                      <img src={imagePath} alt={item.Description} onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/assets/images/default.jpg';
                      }} />
                    </div>
                    <div className="cart-item-details">
                      <h3>{item.Description}</h3>
                      <p>{formatPrice(item.PriceInCents)} each</p>
                    </div>
                    <div className="cart-item-actions">
                      <div className="quantity-controls">
                        <button 
                          onClick={() => updateQuantity(item.Id, item.quantity - 1)}
                          aria-label="Decrease quantity"
                          disabled={isLoading}
                        >
                          <FaMinus />
                        </button>
                        <span>{item.quantity}</span>
                        <button 
                          onClick={() => updateQuantity(item.Id, item.quantity + 1)}
                          aria-label="Increase quantity"
                          disabled={isLoading}
                        >
                          <FaPlus />
                        </button>
                      </div>
                      <button 
                        className="remove-item" 
                        onClick={() => removeFromCart(item.Id)}
                        aria-label="Remove item"
                        disabled={isLoading}
                      >
                        <FaTrash />
                      </button>
                    </div>
                    <div className="cart-item-total">
                      {formatPrice(item.PriceInCents * item.quantity)}
                    </div>
                  </div>
                );
              })}
            </div>
            
            <div className="cart-modal-summary">
              <div className="cart-total">
                <span>Total:</span>
                <span>{formatPrice(totalPrice * 100)}</span>
              </div>
              <div className="cart-modal-actions">
                <button 
                  className="continue-shopping" 
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Continue Shopping
                </button>
                <button 
                  className="checkout-btn" 
                  onClick={onCheckout}
                  disabled={isLoading || cartItems.length === 0}
                >
                  {isLoading ? (
                    <>
                      <FaSpinner className="spinner" />
                      Processing...
                    </>
                  ) : (
                    'Place Order'
                  )}
                </button>
                <button 
                  className="clear-cart" 
                  onClick={clearCart}
                  disabled={isLoading}
                >
                  Clear Cart
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartModal;
